import { flow } from 'fp-ts/lib/function';
import {
  createGetRequest,
  decode,
  fetchApi,
  jsonHeaders,
} from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import {
  featuresResponseCodec,
} from '@/services/api/resources/features/codec';

const baseUrl = '/v2/public/features';
const recordUrl = (): string => `${baseUrl}`;
export const get = flow(
  recordUrl,
  jsonHeaders(createGetRequest),
  fetchApi,
  chain(decode(featuresResponseCodec)),
);
